import React, { useContext, useEffect, useState } from "react";
import { Stack, Button, Card } from "react-bootstrap";
import { getIntegrationsRequest } from "@/services";
import { custom_context } from "../../../utils/custom_context";
import { ConnectSellerAccounts } from '@/components/Modal/application/connect_seller_accounts_modal';
import StatusTag from "../../../components/Common/StatusTag";
import { STATUS_MAP } from "../../../utils/constant";
import { useModalQueryParams } from "@/utils/useModalQueryParams";
import '../dashboard_styles.css';

function ConnectSellerPlatform({ disabled = false }) {
  const { profileData } = useContext(custom_context.ProfileData);
  const [integrationsLoading, setIntegrationsLoading] = useState(false);
  const [showModal, setShowModal] = useModalQueryParams('connect-seller', false);
  const [integrations, setIntegrations] = useState([]);
  const [bankAccountDetails, setBankAccountDetails] = useState({});

  let description = "Connect your Amazon, Noon, Talabat account to unlock higher credit limit.";
  let disableCard = disabled;
  const isValidState = integrations.filter(integration => integration?.status === 'connected')?.length > 0;
  const showAction = true;

  useEffect(() => {
    getIntegrationDetails();
  }, [])

  const getIntegrationDetails = async () => {
    setIntegrationsLoading(true);
    try {
      const resp = await getIntegrationsRequest({ user_id: profileData?.id });
      if (resp?.status) {
        setIntegrations(resp?.results);
      }
    } catch (error) {
      console.error("Error fetching evaluation details:", error);
    } finally {
      setIntegrationsLoading(false);
    }
  };

  return (
    <Card
      className={`dashboardActionCard ${disableCard ? 'disabledCard' : 'activeCard'}`}
      data-testid="fincobox-los-connect-seller-card"
    >
      <Stack direction="horizontal" gap={3}>
        <Stack gap={2} className="actionContent">
          <h4 className="actionCardTitle dash_statusDiv" data-testid="fincobox-los-connect-seller-heading">
            <div>Connect Seller Platform <span className="text-base">(Optional)</span></div>
            {!integrationsLoading && isValidState && (
              <StatusTag status={STATUS_MAP.connected.value} stepComplete={false} label={STATUS_MAP.connected.label} />
            )}
          </h4>
          {!integrationsLoading && (
            <p className="actionCardDescription" data-testid="fincobox-los-connect-seller-description">{description}</p>
          )}
        </Stack>
        {
          showAction && <div>
            <Button
              variant="primary"
              onClick={() => setShowModal(true)}
              disabled={!disableCard && !showAction}
              className="actionButton"
              color="primary"
              data-testid="fincobox-los-connect-seller-btn"
            >
              {isValidState ? 'VIEW' : 'CONNECT'}
            </Button>
          </div>
        }
      </Stack>
      <ConnectSellerAccounts integrations={integrations} showModal={showModal} onHide={() => { getIntegrationDetails(); setShowModal(false) }} />
    </Card >
  );
}

export default ConnectSellerPlatform;
